import { useContext } from 'react';
import { UseConfigResult } from 'models/types';
import { ConfigContext } from './ConfigProvider';

const useConfig = (): UseConfigResult => useContext(ConfigContext);

export default useConfig;
